export const FLAG_GETTING_IDLING_CONSUMPTION_OBSERVATIONS =
  'FLAG_GETTING_IDLING_CONSUMPTION_OBSERVATIONS';
export const GET_IDLING_CONSUMPTION_OBSERVATIONS =
  'GET_IDLING_CONSUMPTION_OBSERVATIONS';
export const CLEAR_IDLING_CONSUMPTION_OBSERVATIONS =
  'CLEAR_IDLING_CONSUMPTION_OBSERVATIONS';
export const FLAG_IDLING_CONSUMPTION_OBSERVATION_ACTIVITY =
  'FLAG_IDLING_CONSUMPTION_OBSERVATION_ACTIVITY';
export const GET_IDLING_CONSUMPTION_OBSERVATION =
  'GET_IDLING_CONSUMPTION_OBSERVATION';
export const CLEAR_IDLING_CONSUMPTION_OBSERVATION =
  'CLEAR_IDLING_CONSUMPTION_OBSERVATION';
export const FLAG_GETTING_IDLING_CONSUMPTION_MOTIVES =
  'FLAG_GETTING_IDLING_CONSUMPTION_MOTIVES';
export const GET_IDLING_CONSUMPTION_MOTIVES = 'GET_IDLING_CONSUMPTION_MOTIVES';
export const CLEAR_IDLING_CONSUMPTION_MOTIVES =
  'CLEAR_IDLING_CONSUMPTION_MOTIVES';
